<template>
  <div>
    <title-bar :items="[{ title }]" />

    <div class="box">
      <b-tabs type="is-boxed">
        <b-tab-item label="Datos personales">
          <form-datos-personales></form-datos-personales>
        </b-tab-item>
        <b-tab-item label="Cuenta de usuario">
          <form-cuenta-usuario></form-cuenta-usuario>
        </b-tab-item>
        <b-tab-item label="Actividades recientes">
          <ActividadesRecientes />
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import FormCuentaUsuario from '../components/FormCuentaUsuario.vue';
import FormDatosPersonales from '../components/FormDatosPersonales.vue';
import ActividadesRecientes from '../components/ActividadesRecientes.vue';
export default {
  components: { FormDatosPersonales, FormCuentaUsuario, ActividadesRecientes },
  computed:{
    title(){
      return this.$route.meta.title || "";
    }
  },
  created(){
    this.$store.dispatch("auth/LogsRequest")
  }
};
</script>
